import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoginModel } from './loginModel';
import { LoginResponse } from './loginResponse';
import { Const } from 'src/app/const';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private token: string | null = null;
  private email: string | null = null;
  public emailObservable = new BehaviorSubject<string | null>(this.email);

  constructor(private http: HttpClient, private oidcSecurityService: OidcSecurityService) {
    //refresh token and email from local storage
    this.getToken();
    this.getEmail();
  }

  login(loginModel: LoginModel): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(`${environment.apiUrl}/ui-user/login`, loginModel).pipe(
      catchError(this.handleError<LoginResponse>('login', undefined))
    );;
  }

  logout(): void {
    this.oidcSecurityService
      .logoff()
      .subscribe((result) => console.log(result));
    
    this.token = null;
    localStorage.removeItem(Const.STORAGE_AUTH_TOKEN);

    this.email = null;
    localStorage.removeItem(Const.STORAGE_AUTH_EMAIL);
    this.emailObservable.next(this.email);
  }

  setAuthData(email: string, token: string): void {
    this.token = token;
    localStorage.setItem(Const.STORAGE_AUTH_TOKEN, token);

    this.email = email;
    this.emailObservable.next(email);
    localStorage.setItem(Const.STORAGE_AUTH_EMAIL, email);
  }

  getToken(): string | null {
    if (!this.token) {
      this.token = localStorage.getItem(Const.STORAGE_AUTH_TOKEN);
    }

    return this.token;
  }

  getEmail(): string | null {
    if (!this.email) {
      this.email = localStorage.getItem(Const.STORAGE_AUTH_EMAIL);
      this.emailObservable.next(this.email);
    }

    return this.email;
  }

  isAuthenticated(): boolean {
    const token = this.getToken();
    return !!token;
  }

  getAuthorizationHeader(): HttpHeaders {
    const token = this.getToken();
    return new HttpHeaders({ Authorization: `Bearer ${token}` });
  }

  private log(message: string) {
    console.log(`AuthenticationService: ${message}`);
  }

  /**
 * Handle Http operation that failed.
 * Let the app continue.
 *
 * @param operation - name of the operation that failed
 * @param result - optional value to return as the observable result
 */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
